import axios from '@/utils/axios'
import {business} from '../../common'
import {getUrlPrefixByRole} from '@/utils/role'

/**
 * 获取诊所管理列表(不分权限)
 */
export const clinicList = (pageInfo, expiring, userCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/list`,
    method: 'post',
    data: pageInfo,
    params: {expiring, userCode}
  })
}

/**
 * 诊所名字已存在
 * @returns {*} boolean true: 已存在 false：不存在
 */
export const clinicNameAlreadyExists = (clinicName, clinicCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/clinicNameValidate`,
    method: 'get',
    params: {clinicName, clinicCode}
  })
}

/**
 * 添加诊所
 */
export const addClinic = (clinicForm) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/add`,
    method: 'post',
    data: clinicForm
  })
}

/**
 * 编辑诊所
 * @returns {*}
 */
export const editClinic = (clinicForm) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/edit`,
    method: 'post',
    data: clinicForm
  })
}
/**
 * 获取诊所信息
 * @returns {*}
 */
export const clinicInfo = (clinicCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/info/${clinicCode}`,
    method: 'get'
  })
}

/**
 * 删除诊所
 * @returns {*} -
 */
export const deleteClinic = (clinicCodes) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/delete`,
    method: 'delete',
    data: clinicCodes
  })
}

/**
 * 关联医生到诊所
 */
export const doctor2Clinic = (clinicCode, userCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/doctor2Clinic/${clinicCode}/${userCode}`,
    method: 'get'
  })
}

/**
 * 删除诊所下的医生关联
 */
export const deleteDoctor2Clinic = (clinicCode, userCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/deleteDoctor2Clinic/${clinicCode}`,
    method: 'delete',
    data: userCode
  })
}

/**
 * 获取一个月内即将到期的诊所数
 */
export const expiringNum = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/expiring/num`,
    method: 'get'
  })
}

/**
 * 导出
 */
export const queryExport = (pageInfo, expiring) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/clinic/queryExport`,
    method: 'post',
    data: pageInfo,
    responseType: 'arraybuffer',
    params: {expiring}
  })
}



// WEBPACK FOOTER //
// ./src/api/business/clinic/index.js